module.exports = __webpack_public_path__ + "img/back-button.ee70c024.svg";